<template>
  <BittsAlert
    color="info"
    class="mb-16"
    data-testid="user-management-disabled-banner"
    message="User management is handled by your organization"
    description="Your team's users are managed in your company's identity system. To add, edit, or remove users, please reach out to your admins."
  />
</template>

<script setup lang="ts">
import { BittsAlert } from '@crossbeam/bitts';
</script>
